export default __webpack_public_path__ + "static/media/DifferentShopping.7872baf0.svg";